import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { readSingleAppData, readAppData } from "shared/redux-store/dataReaders";
import OrderUnitDetails from "./OrderUnitDetails";

import {
  addOrderUnitProduct,
  removeOrderUnitProduct,
  updateOrderUnitProduct,
  requestOrderUnitApproval,
} from "./orderUnitDetailsActions";

const mapStateToProps = state => {
  return {
    orderUnit: readSingleAppData(state, "orderUnit"),
    allProducts: readAppData(state, "products"),
    isSubmitting: state.app.isSubmitting,
    submitErrorCode: state.app.submitErrorCode,
    submitErrorMessages: state.app.submitErrorMessages,
    submitSuccessMessage: state.app.submitSuccessMessage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addOrderUnitProductFn: bindActionCreators(addOrderUnitProduct, dispatch),
    updateOrderUnitProductFn: bindActionCreators(
      updateOrderUnitProduct,
      dispatch,
    ),
    removeOrderUnitProductFn: bindActionCreators(
      removeOrderUnitProduct,
      dispatch,
    ),
    requestOrderUnitApprovalFn: bindActionCreators(
      requestOrderUnitApproval,
      dispatch,
    ),
  };
};

const OrderUnitDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderUnitDetails);

export default OrderUnitDetailsContainer;
